export default {
  root: {
    fontSize: 13,
    marginTop: 8,
  },
};
